export const NEWSLETTER_AUDIENCE_OPTIONS = [
  "Shopper",
  "Grocer",
  "Other",
] as const;

export type NewsletterAudience = (typeof NEWSLETTER_AUDIENCE_OPTIONS)[number];
export type NewsletterSignupSource =
  | "website_popup"
  | "newsletter_page"
  | "blog_article"
  | "homepage_grocery_brief";

export type NewsletterSignupResult = {
  success: boolean;
  message: string;
  alreadySubscribed?: boolean;
  memberId?: string;
};

type NewsletterSignupInput = {
  email: string;
  groups: string[];
  source: NewsletterSignupSource;
};

export async function subscribeToNewsletter({
  email,
  groups,
  source,
}: NewsletterSignupInput): Promise<NewsletterSignupResult> {
  const response = await fetch("/api/mailchimp", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email: email.trim(), groups, source }),
  });

  const result = (await response.json().catch(() => ({}))) as Partial<NewsletterSignupResult>;
  if (!response.ok) {
    throw new Error(result.message || "Something went wrong. Please try again.");
  }

  return {
    success: result.success === true,
    message: result.message || "Successfully subscribed to newsletter",
    alreadySubscribed: result.alreadySubscribed,
    memberId: result.memberId,
  };
}
